var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGraphDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.5V18H19.9394L13.5 11.5606L10.2802 14.7802C10.2106 14.8499 10.128 14.9052 10.037 14.9429C9.94601 14.9806 9.84849 15 9.75 15C9.65151 15 9.55399 14.9806 9.463 14.9429C9.37202 14.9052 9.28936 14.8499 9.21975 14.7802L1.5 7.06058L2.56058 6L9.75 13.1894L12.9697 9.96975C13.0394 9.90008 13.122 9.8448 13.213 9.80709C13.304 9.76938 13.4015 9.74997 13.5 9.74997C13.5985 9.74997 13.696 9.76938 13.787 9.80709C13.878 9.8448 13.9606 9.90008 14.0303 9.96975L21 16.9394V12H22.5V19.5H15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGraphDown);
export default __webpack_public_path__ + "static/media/ic-graph-down.3809d3632ef0cdcf6140d6ca1c6da72b.svg";
export { ForwardRef as ReactComponent };